/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaVacasaHold: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="vacasaHold" viewBox="0 0 16 17">
      <title>user</title>
      <g
        id="Main-Screens"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="-Unit-Badges---Occupied-Variants"
          transform="translate(-207.000000, -303.000000)"
          fill="#2C3439"
        >
          <g
            id="Unit-Status-Lockup-/-Occupied"
            transform="translate(207.000000, 264.000000)"
          >
            <g id="Group" transform="translate(0.000000, 39.000000)">
              <path
                d="M9.55304853,7.29709613 L9.20881394,7.08178858 L8.17651815,6.43610166 C8.03140977,6.34534659 7.85262864,6.34534659 7.70752027,6.43613112 L6.67525168,7.08175912 L6.33390021,7.29526924 L5.30163162,7.9409267 C5.15652325,8.03168177 5.06714628,8.19940184 5.06714628,8.38091197 L5.06714628,9.67225635 L5.06714628,13.2328604 L5.2782402,13.2328604 L5.48938853,13.2328604 L5.70050965,13.2328604 L5.91165797,13.2328604 L6.12277909,13.2328604 L6.33390021,13.2328604 L6.33390021,9.17325083 C6.33390021,8.9917407 6.42330438,8.82402063 6.56841275,8.73326556 L7.70754747,8.02077937 C7.85262864,7.93002431 8.03143697,7.93002431 8.17651815,8.02077937 L9.3185632,8.73509245 C9.46367157,8.82584751 9.55304853,8.99356759 9.55304853,9.17507772 L9.55304853,13.2328604 L9.76419686,13.2328604 L9.97531798,13.2328604 L10.1864391,13.2328604 L10.3975874,13.2328604 L10.6087085,13.2328604 L10.8198297,13.2328604 L10.8198297,9.67405378 L10.8198297,8.38273886 C10.8198297,8.2012582 10.7304527,8.03350866 10.5853443,7.94275359 L9.55304853,7.29709613 Z"
                id="Guest"
              ></path>
              <path
                d="M12.0866217,5.71245378 L9.20879762,3.91246851 L8.17650183,3.26681105 C8.03142065,3.17605599 7.85263952,3.17605599 7.70753115,3.26681105 L6.67523536,3.91246851 L3.80034883,5.71062689 L2.76805304,6.35628435 C2.62297187,6.44703941 2.5335677,6.61475948 2.5335677,6.79626961 L2.5335677,8.08758453 L2.5335677,13.2328663 L2.74468882,13.2328663 L2.95583714,13.2328663 L3.16695827,13.2328663 L3.37807939,13.2328663 L3.58920051,13.2328663 L3.80034883,13.2328663 L3.80034883,7.58860847 C3.80034883,7.40709834 3.8897258,7.23937827 4.03483417,7.1486232 L7.70753115,4.85148877 C7.85263952,4.7607337 8.03142065,4.7607337 8.17650183,4.85148877 L11.8521363,7.15042063 C11.9972447,7.24117569 12.0866217,7.40892523 12.0866217,7.59043536 L12.0866217,13.2328663 L12.29777,13.2328663 L12.5088639,13.2328663 L12.7200122,13.2328663 L12.9311606,13.2328663 L13.1422817,13.2328663 L13.3534028,13.2328663 L13.3534028,8.08941142 L13.3534028,6.7980965 C13.3534028,6.61658637 13.2640258,6.4488663 13.1189175,6.35811123 L12.0866217,5.71245378 Z"
                id="Owner"
              ></path>
              <path
                d="M8.23469651,0.0977596886 C8.08858304,0.00667973547 7.90850244,0.00667973547 7.76236158,0.0977596886 L0.23614833,4.78706178 C0.090007469,4.87814173 -5.439864e-06,5.04637802 -5.439864e-06,5.22850836 L-5.439864e-06,15.5197449 C-5.439864e-06,15.8012325 0.211494764,16.0294497 0.472329493,16.0294497 L6.3789952,16.0294497 L6.3789952,14.6526377 L1.27578921,14.6526377 L1.27578921,6.02339602 C1.27578921,5.84129524 1.36582951,5.67302938 1.51197037,5.58197899 L7.76236158,1.687535 C7.90850244,1.5964846 8.08858304,1.5964846 8.23469651,1.687535 L14.4880461,5.58378226 C14.634187,5.67483265 14.7241999,5.84309851 14.7241999,6.02519929 L14.7241999,14.6526377 L9.62102131,14.6526377 L9.62102131,16.0294497 L15.527687,16.0294497 C15.7885217,16.0294497 15.9999946,15.8012325 15.9999946,15.5197449 L15.9999946,5.2303412 C15.9999946,5.04821085 15.9099817,4.879945 15.7638408,4.78889461 L8.23469651,0.0977596886 Z"
                id="Vacasa"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaVacasaHold)
